import { FC } from "react";

import BranchSettingsContainer from "@app/containers/branchSettings";

const BranchSettingsPage: FC = () => <BranchSettingsContainer />;

export default BranchSettingsPage;
